import { request } from '../http';

export type InAppNotification = {
  id: string;
  userId: string;
  organizationId?: string | null;
  category: string;
  notificationType: string;
  title: string;
  body: string;
  severity: string;
  actionUrl?: string | null;
  read: boolean;
  readAt?: string | null;
  createdAt?: string | null;
};

export type SubscriptionStatus = {
  organizationId: string | null;
  lifecycleState: string;
  lifecycleLabel: string;
  planSlug?: string | null;
  subscriptionActive: boolean;
  expiresAt?: string | null;
  graceUntil?: string | null;
  autoRenew: boolean;
  paymentStatus: string;
  entitlementSource?: string | null;
};

export type OrganizationHealth = {
  organizationId: string;
  health: string;
  lifecycleState: string;
  lifecycleLabel: string;
  planSlug?: string | null;
  subscriptionActive: boolean;
  expiresAt?: string | null;
  graceUntil?: string | null;
  paymentStatus: string;
  unlimited: boolean;
  usage: {
    activeSearches: number;
    recipients: number;
    notificationsSentToday: number;
  };
  limits: {
    maxSearches?: number | null;
    maxNotificationRecipients?: number | null;
    maxNotificationsPerDay?: number | null;
    minScrapeIntervalMinutes?: number | null;
  };
  entitlementSource?: string | null;
};

export type BillingAttention = {
  expiringSoon: Array<{
    organizationId: string;
    organizationName?: string | null;
    organizationSlug?: string | null;
    planSlug?: string | null;
    expiresAt?: string | null;
    graceUntil?: string | null;
  }>;
  gracePeriod: BillingAttention['expiringSoon'];
  expired: BillingAttention['expiringSoon'];
  failedReminders: Array<{
    organizationId: string;
    notificationType: string;
    status: string;
    createdAt?: string | null;
  }>;
};

export const notificationsService = {
  list(unreadOnly = false) {
    const q = unreadOnly ? '?unread_only=true' : '';
    return request<{ items: InAppNotification[]; unreadCount: number }>(`/notifications${q}`);
  },

  markRead(id: string) {
    return request<{ ok: boolean }>(`/notifications/${id}/read`, { method: 'POST' });
  },

  markAllRead() {
    return request<{ marked: number }>('/notifications/read-all', { method: 'POST' });
  },
};

export const subscriptionService = {
  status() {
    return request<SubscriptionStatus>('/subscription/status');
  },

  health() {
    return request<OrganizationHealth>('/organization/health');
  },

  billingAttention() {
    return request<BillingAttention>('/admin/billing/attention');
  },
};
